const styles = theme => ({
	container: {
		alignSelf: 'flex-end',
		textAlign: 'center',
		fontWeight: 'lighter',
		fontSize: 12,
		margin: 'auto auto 0',
		minHeight: '72px',
		color: '#666',
		'& p': {
			margin: '4px'
		},
		'@global em': {
			fontStyle: 'normal',
			textDecoration: 'underline'
		},
		'@global a': {
			color: theme.palette.primary[400]
		}
	}
});

export default styles;



// WEBPACK FOOTER //
// ./src/client/components/main/footer/styles.js